/* Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { NvHigListItemCoreData, NvHigListItemHeadlineTextStyle } from '../../../models/hig-list-item.types';

@Component({
    selector: 'nv-hig-list-item-core',
    templateUrl: './nv-hig-list-item-core.component.html',
    styleUrl: './nv-hig-list-item-core.component.scss',
    imports: [MatIconModule, TranslateModule]
})
export class NvHigListItemCoreComponent {
    readonly headlineTextStyle = NvHigListItemHeadlineTextStyle;

    data: NvHigListItemCoreData;
    @Input() set cardData(x: NvHigListItemCoreData) {
        this.data = x;
        // Set top padding when both headline and supportingText exist
        this.topPadding = !!this.data.supportingText && !!this.data.headline?.text;
        // Sets text to centerAlign when exactly one of them exists (but not both or neither)
        this.centerAlign = !!this.data.supportingText !== !!this.data.headline?.text;
    }

    topPadding = false;
    centerAlign = false;
}
